import { createStore } from '@nile/mangifera/src/StoreManager/store/createStore';

const aiNotificationStoreConfig = {
  id: 'aiNotificationStore',
  initialState: {
    initialized: false,
    notifications: null,
    count: 0
  },

  methods: (set, get) => ({
    setInitialized: (value: boolean) => {
      set({
        initialized: value
      });
    },
    setNotifications: (data: any) => {
      set({
        notifications: data
      });
    },
    setCount: (num: number) => {
      set({
        count: num
      });
    }
  }),
  cache: {
    expiryTime: 300,
    strategy: 'memory',
    tabBehavior: 'persist',
    clearOnRefresh: true,
    scope: 'global'
  }
};

export const useAINotificationStore = createStore(aiNotificationStoreConfig);
